import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { Workflows } from '../model/workflows.model';
import { WorkflowsService } from '../service/workflows.service';

@Component({
    selector: 'index-workflows',
    templateUrl: './index-workflows.component.html',
    styleUrls: ['./index-workflows.component.scss']
})
export class IndexWorkflowsComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    // Table display
    displayedColumns: string[] = ['EDIT', 'NAME'];

    // Table results
    tableDataSources: MatTableDataSource<Workflows>[] = [];

    // Results
    results: Workflows[] = [];
    displayName: string = '';
    filter: string = '';

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(private workflowsService: WorkflowsService) {}

    ngOnInit(): void {
        this.getWorkflows();
    }

    getWorkflows() {
        this.isLoading = true;

        this.workflowsService.index().subscribe({
            next: (res) => {
                this.results = res.workflows;
            },
            error: (err) => {
                this.results = [];
                this.msg = { SUCCESS: false, MSG: 'Error retrieving Workflows.' };
            },
            complete: () => {
                // Updates the Tables to be displayed w/ this.results
                this.updateDataSource();

                // Display results
                this.isLoading = false;
            }
        });
    }

    updateDataSource() {
        this.tableDataSources = [];

        setTimeout(() => {
            // Data
            let dataSource = new MatTableDataSource<Workflows>();
            dataSource.data = this.results;

            // Paginator
            //dataSource.paginator = this.paginators.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
            dataSource.sort.active = defaultSort.active;
            dataSource.sort.direction = defaultSort.direction;
            dataSource.sort.sortChange.emit(defaultSort);
            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.tableDataSources.push(dataSource);
        });
    }

    setFilter() {
        this.tableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.filter.trim().toLocaleLowerCase();
        });
    }
}
